import React from 'react';

const CCIcon = (props) => (
  <svg
    data-type="fill"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
    {...props}
  >
    <path
      d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 9.5 8 C 7.5788117 8 6 9.5788117 6 11.5 L 6 12.5 C 6 14.421188 7.5788117 16 9.5 16 C 10.283249 16 11.017372 15.737671 11.601562 15.298828 L 10.398438 13.701172 C 10.146629 13.890329 9.8427513 14 9.5 14 C 8.6591883 14 8 13.340812 8 12.5 L 8 11.5 C 8 10.659188 8.6591883 10 9.5 10 C 9.8427513 10 10.146628 10.109671 10.398438 10.298828 L 11.601562 8.7011719 C 11.017372 8.2623293 10.283249 8 9.5 8 z M 15.5 8 C 13.578812 8 12 9.5788117 12 11.5 L 12 12.5 C 12 14.421188 13.578812 16 15.5 16 C 16.283249 16 17.017371 15.737671 17.601562 15.298828 L 16.398438 13.701172 C 16.146629 13.890329 15.842751 14 15.5 14 C 14.659188 14 14 13.340812 14 12.5 L 14 11.5 C 14 10.659188 14.659188 10 15.5 10 C 15.842751 10 16.146629 10.109671 16.398438 10.298828 L 17.601562 8.7011719 C 17.017371 8.2623293 16.283249 8 15.5 8 z"
      fill="currentColor"
    />
  </svg>
);

export default CCIcon;
